<template>
  <div class="charts">
    <h3>通过产生利润所获得的收益回报</h3>
    <div class="description">
      <p>X: 产生月利润 - Y: 收益回报</p>
      <p>以单月计</p>
      <p>含：底薪加成、提成、提成奖励</p>
      <p>未含：基本底薪、销量奖励、年终奖</p>
    </div>
    <div ref="monthlyBonus"></div>
    <h3>年终奖</h3>
    <div class="description">
      <p>X: 产生月均利润 - Y: 收益回报</p>
      <p>含：年终奖</p>
      <p>未含：基本底薪、底薪加成、提成、提成奖励、销量奖励</p>
    </div>
    <div ref="yearEndBonus"></div>
    <h3>月总收益</h3>
    <div class="description">
      <p>X: 产生月利润 - Y: 收益回报</p>
      <p>含：基本底薪、底薪加成、提成、提成奖励</p>
      <p>未含：销量奖励、年终奖</p>
    </div>
    <div ref="monthly"></div>
    <h3>年总收益参考</h3>
    <div class="description">
      <p>受计算方式 (月/年) 影响，参考值与实际会有一定出入</p>
      <p>X: 产生月均利润 - Y: 收益回报</p>
      <p>含：基本底薪、底薪加成、提成、提成奖励、年终奖</p>
      <p>未含：销量奖励</p>
    </div>
    <div ref="yearly"></div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import range from "lodash.range";
import flatten from "just-flatten-it";
import formula, { BASE } from "../common/formula";

function thousands(number) {
  return (number / 1000).toFixed() + "k";
}

function createChart(container, data, options = {}) {
  const chart = new Chart({
    container,
    forceFit: true,
    height: 480,
    ...options
  });
  chart.source(data);
  chart.scale({
    x: {
      alias: "利润",
      tickCount: 10
    },
    y: {
      alias: "收益"
    }
  });
  return chart;
}

function printMonthlyBonus(container) {
  const data = range(0, 160000, 10000).map(profit => ({
    x: thousands(profit),
    y: formula(profit).monthly - BASE
  }));
  const chart = createChart(container, data);
  chart.line().position("x*y");
  chart
    .point()
    .position("x*y")
    .size(3)
    .shape("circle")
    .style({
      stroke: "#fff",
      lineWidth: 1
    });
  chart.render();
}

function printYearEndBonus(container) {
  const data = range(0, 160000, 10000).map(profit => ({
    x: thousands(profit),
    y: formula(profit).yearEndBonus
  }));
  const chart = createChart(container, data);
  chart.line().position("x*y");
  chart
    .point()
    .position("x*y")
    .size(3)
    .shape("circle")
    .style({
      stroke: "#fff",
      lineWidth: 1
    });
  chart.render();
}

function printMonthly(container) {
  const profits = range(0, 310000, 10000);
  const types = [
    { key: "commission", alias: "提成" },
    { key: "baseAddition", alias: "底薪加成" },
    { key: "commissionBonus", alias: "提成奖励" },
    { key: "BASE", alias: "基本底薪" }
  ];
  const data = flatten(
    types.map(({ key, alias }) =>
      profits.map(profit => ({
        type: alias,
        x: thousands(profit),
        y: formula(profit)[key]
      }))
    )
  );
  const chart = createChart(container, data);

  chart
    .intervalStack()
    .position("x*y")
    .color("type", ["#40a9ff", "#1890ff", "#096dd9", "#0050b3"])
    .opacity(1);
  chart.render();
}

function printYearly(container) {
  const profits = range(0, 310000, 10000);
  const types = [
    { key: "yearEndBonus", alias: "年终奖", coefficient: 1 },
    { key: "commission", alias: "提成", coefficient: 12 },
    { key: "baseAddition", alias: "底薪加成", coefficient: 12 },
    { key: "commissionBonus", alias: "提成奖励", coefficient: 12 },
    { key: "BASE", alias: "基本底薪", coefficient: 12 }
  ];
  const data = flatten(
    types.map(({ key, alias, coefficient }) =>
      profits.map(profit => ({
        type: alias,
        x: thousands(profit),
        y: formula(profit)[key] * coefficient
      }))
    )
  );
  const chart = createChart(container, data);

  chart
    .intervalStack()
    .position("x*y")
    .color("type", ["#40a9ff", "#1890ff", "#096dd9", "#0050b3"])
    .opacity(1);
  chart.render();
}

export default {
  mounted() {
    printMonthlyBonus(this.$refs.monthlyBonus);
    printYearEndBonus(this.$refs.yearEndBonus);
    printMonthly(this.$refs.monthly);
    printYearly(this.$refs.yearly);
  }
};
</script>

<style lang="postcss" scoped>
.charts {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}
.description {
  font-size: 12px;
  color: hsl(200, 1%, 50%);
  margin: 0 0 24px;
  p {
    margin: 0;
    padding: 0;
  }
}
</style>
